export const removeProperties = (files, properties) => {
	return files.map((file) => {
		let newFile = { ...file };
		properties.forEach((prop) => {
			delete newFile[prop];
		});
		return newFile;
	});
};
